import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { TopicIntakePage } from './pages/TopicIntakePage';
import { PipelinePage } from './pages/PipelinePage';
import { ScriptApprovalPage } from './pages/ScriptApprovalPage';
import { VideoApprovalPage } from './pages/VideoApprovalPage';
import { LibraryPage } from './pages/LibraryPage';
import { CostsPage } from './pages/CostsPage';
import { SettingsPage } from './pages/SettingsPage';

const NAV = [
  { to: '/', label: 'Topic Intake' },
  { to: '/pipeline', label: 'Pipeline' },
  { to: '/scripts', label: 'Script Approval' },
  { to: '/videos', label: 'Video Approval' },
  { to: '/library', label: 'Library' },
  { to: '/costs', label: 'Costs' },
  { to: '/settings', label: 'Settings' },
];

function App() {
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen grid grid-cols-[240px_1fr]">
      <aside className="bg-parchment-100 border-r border-parchment-300 p-6 flex flex-col gap-2">
        <div className="mb-6">
          <h1 className="text-xl font-heading font-bold text-forest-700">
            Enneking Media Studio
          </h1>
          <p className="text-xs font-mono text-parchment-700 mt-1">
            video generator · v0.1
          </p>
        </div>
        <nav className="flex flex-col gap-1">
          {NAV.map((item) => {
            const active = pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-button px-4 py-2.5 text-sm font-medium transition ${
                  active
                    ? 'bg-forest-500 text-parchment-50 shadow-neumorphic-inset'
                    : 'text-parchment-800 hover:bg-parchment-200'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>
        <div className="mt-auto pt-6 border-t border-parchment-300">
          <p className="text-[10px] font-mono text-parchment-700 leading-relaxed">
            channel #1: data-driven
            <br />
            finance explainers
            <br />
            <span className="text-forest-600">100% AI voice</span>
          </p>
        </div>
      </aside>
      <main className="p-8 overflow-auto">
        <Routes>
          <Route path="/" element={<TopicIntakePage />} />
          <Route path="/pipeline" element={<PipelinePage />} />
          <Route path="/scripts" element={<ScriptApprovalPage />} />
          <Route path="/videos" element={<VideoApprovalPage />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/costs" element={<CostsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
